import React from 'react';
import { useParams } from 'react-router-dom';

export const PackageDetailsPage = () => {
  const { packageId } = useParams();

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">Detalhes do Pacote</h1>
      <div className="bg-white shadow rounded-lg p-6">
        <p>ID do Pacote: {packageId}</p>
        {/* Adicionar mais detalhes do pacote aqui */}
      </div>
    </div>
  );
};

